var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useState } from "react";
import { Accordion } from "react-bootstrap";
import EdButton from "../edbutton/edButton";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import Drawer from "react-bottom-drawer";
import GenericTabs from "../GenericTabs";
import CustomDateFilter from "./CustomDateFilter";
export var updateChecked = function (e, filterName, key, setSelected, type) {
    if (e && filterName && e.target.type === "radio") {
        setSelected(function (prevState) {
            return prevState.map(function (gcFilter) {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list.map(function (val) {
                        if (val.childlist && val.childlist.list) {
                            return val.childlist.list.map(function (child) {
                                if (child.key == e.target.value)
                                    child.selected = true;
                                else
                                    child.selected = false;
                            });
                        }
                        else {
                            if (val.key == e.target.value)
                                val.selected = true;
                            else
                                val.selected = false;
                        }
                    });
                }
                return gcFilter;
            });
        });
    }
    else if (e && filterName && e.target.type === "checkbox") {
        setSelected(function (prevState) {
            return prevState.map(function (gcFilter) {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list[key].selected = e.target.checked;
                }
                return gcFilter;
            });
        });
    }
    else if (type && filterName && type === "tab") {
        setSelected(function (prevState) {
            return prevState.map(function (gcFilter) {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list.map(function (x, i) {
                        if (i === key) {
                            x.selected = true;
                        }
                        else {
                            x.selected = false;
                        }
                    });
                }
                return gcFilter;
            });
        });
    }
};
export var GenericFilter = function (props) {
    var _a;
    var device = DeviceContext();
    var _b = __read(useState(false), 2), customSelect = _b[0], setcustomSelect = _b[1];
    var _c = __read(useState(0), 2), counts = _c[0], setCount = _c[1];
    var _d = __read(React.useState(props.selectedFilters), 2), selected = _d[0], setSelected = _d[1];
    var _e = __read(React.useState(props.defaultActiveKey ? props.defaultActiveKey : (_a = props === null || props === void 0 ? void 0 : props.links[0]) === null || _a === void 0 ? void 0 : _a.eventKey), 2), activeKey = _e[0], setActiveKey = _e[1];
    var totalCounts = useMemo(function () {
        var count = 0;
        selected === null || selected === void 0 ? void 0 : selected.map(function (x) {
            var _a, _b;
            ((_a = x.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                ((_b = x.list) === null || _b === void 0 ? void 0 : _b.map(function (z) {
                    var _a, _b, _c, _d;
                    if (z.selected) {
                        count++;
                        setCount(counts + 1);
                    }
                    else if ((z === null || z === void 0 ? void 0 : z.childlist) && ((_b = (_a = z === null || z === void 0 ? void 0 : z.childlist) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        return (_d = (_c = z.childlist) === null || _c === void 0 ? void 0 : _c.list) === null || _d === void 0 ? void 0 : _d.map(function (z) {
                            if (z.selected)
                                setCount(counts + 1);
                        });
                    }
                }));
        });
        return count;
    }, [selected]);
    // useEffect(() => {}, [counts]);
    var CountFunction = function () {
        if (counts > 0) {
            (props === null || props === void 0 ? void 0 : props.setCount) && (props === null || props === void 0 ? void 0 : props.setCount(counts));
        }
        else {
            (props === null || props === void 0 ? void 0 : props.setCount) && (props === null || props === void 0 ? void 0 : props.setCount(0));
        }
    };
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.counts) === 0) {
            setCount(0);
        }
    }, [props === null || props === void 0 ? void 0 : props.counts]);
    useEffect(function () {
        if (props.defaultActiveKey)
            setActiveKey(props.defaultActiveKey);
    }, [props.defaultActiveKey]);
    useEffect(function () {
        setSelected(props.selectedFilters);
    }, [props.selectedFilters]);
    var EachFilter = function (eachFilterprops) {
        var _a;
        return (React.createElement("div", { id: "filter-show-hide", className: "filterasset-drop-body" },
            React.createElement("ul", { className: "bodylist me-3", id: "asset" },
                React.createElement("div", { className: "d-flex mb-2 ".concat((eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.clear) && (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.selectAll)
                        ? "justify-content-between align-items-center"
                        : "justify-content-end") },
                    (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.selectAll) &&
                        eachFilterprops.selectedType === "checkbox" && (React.createElement("li", { className: "d-flex inside-list align-items-center common-checkbox-custom mb-0" },
                        React.createElement("label", { className: "hand_cursor" },
                            React.createElement("input", { type: eachFilterprops.selectedType, onChange: function (e) {
                                    selectedAllHandler(e, eachFilterprops.filterName);
                                }, className: "hand_cursor", checked: eachFilterprops.list.every(function (x) { return x.selected; }), name: eachFilterprops.propertyKey, value: "Select All" }),
                            React.createElement("span", { className: "bodylist-title DMSan_14_500 txt_primaryGrey" }, "Select All")))),
                    (eachFilterprops === null || eachFilterprops === void 0 ? void 0 : eachFilterprops.clear) && (React.createElement("div", { className: "" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: eachFilterprops.selectedType === "radio"
                                ? "Clear Selection"
                                : "Clear All", className: "dm-fam", onClick: function () {
                                clearSectionWise(eachFilterprops.filterName);
                            } })))),
                ((_a = eachFilterprops.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                    eachFilterprops.list.map(function (val, idx) {
                        return (React.createElement(React.Fragment, null,
                            React.createElement("div", { key: idx, className: "label-list ".concat(val === null || val === void 0 ? void 0 : val.className) },
                                React.createElement("li", { className: "d-flex inside-list align-items-center common-checkbox-custom " },
                                    React.createElement("label", { className: "hand_cursor radio_btn" },
                                        React.createElement("input", { type: eachFilterprops.selectedType, onChange: function (e) {
                                                updateChecked(e, eachFilterprops.filterName, idx, setSelected);
                                            }, className: "hand_cursor inputStyle", name: eachFilterprops.propertyKey, value: val.key, checked: val.selected, onClick: function () {
                                                {
                                                    val.customDateFilter ? setcustomSelect(true) : "";
                                                }
                                            } }),
                                        React.createElement("span", { className: "bodylist-title DMSan_14_500 txt_primaryGrey hand_cursor" }, val.title))),
                                customSelect ? (React.createElement(React.Fragment, null, val.customDateFilter && (React.createElement(CustomDateFilter, { customDateFilter: props === null || props === void 0 ? void 0 : props.customDateFilter, applyDate: function (data) {
                                        props === null || props === void 0 ? void 0 : props.setCustomDateFilter(data);
                                    } })))) : (""))));
                    }))));
    };
    var selectedAllHandler = function (e, filterName) {
        if (e && filterName && e.target.type === "checkbox") {
            setSelected(function (prevState) {
                return prevState.map(function (gcFilter) {
                    if (gcFilter.filterName === filterName) {
                        gcFilter.list.map(function (x) {
                            x.selected = e.target.checked;
                        });
                    }
                    return gcFilter;
                });
            });
        }
    };
    var clearSectionWise = function (filterName) {
        setSelected(function (prevState) {
            return prevState.map(function (gcFilter) {
                if (gcFilter.filterName === filterName) {
                    gcFilter.list.map(function (val) {
                        val.selected = false;
                        if (val.childlist && val.childlist.list) {
                            return val.childlist.list.map(function (child) {
                                child.selected = false;
                            });
                        }
                    });
                }
                return gcFilter;
            });
        });
    };
    // const updateChecked = (
    //   e: React.ChangeEvent<HTMLInputElement>,
    //   filterName: string,
    //   key?: string | number
    // ) => {
    //   setSelected((ui: IFilters[]) => {
    //     let newUIUpdate = JSON.parse(JSON.stringify(ui));
    //     const updateIndex = ui.findIndex(
    //       (x: IFilters) => x.filterName === filterName
    //     );
    //     if (updateIndex > -1) {
    //       newUIUpdate[updateIndex].list = newUIUpdate[updateIndex].list.map(
    //         (x: IFilterList, k: number) => {
    //           if (key === k) {
    //             return { ...x, selected: e.target.checked };
    //           }
    //           return x;
    //         }
    //       );
    //     }
    //     return newUIUpdate;
    //   });
    // };
    var ClearAll = function () {
        props.setSelectedFilters(JSON.parse(JSON.stringify(props.links)));
        setSelected(props.links);
        setCount(0);
        props.setOpenFilter(false);
        props === null || props === void 0 ? void 0 : props.clearAll();
    };
    useEffect(function () {
        if (props.defaultActiveKey)
            setActiveKey(props.defaultActiveKey);
        if (props.selectedFilters)
            setSelected(props.selectedFilters);
    }, [props.defaultActiveKey, props.selectedFilters]);
    return (React.createElement(React.Fragment, null, props.openFilter ? (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isMobile) ? (React.createElement(React.Fragment, null,
        React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: function () { return props.setOpenFilter(false); }, isVisible: props.openFilter, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
            React.createElement("div", { className: "mob-filterasset-drop funds-filter ".concat(props.externalClassName) },
                React.createElement("div", { className: "mob-filterasset-drop-head" },
                    React.createElement("div", { className: "down-bar container" },
                        React.createElement("span", { className: "down-bar-left" }, "Filters"),
                        React.createElement("input", { className: "down-bar-right", type: "button", value: "Clear All", onClick: function () { return ClearAll(); } }))),
                React.createElement("div", { className: "mob-filterasset-drop-body" }, (selected === null || selected === void 0 ? void 0 : selected.length) > 0 &&
                    (selected === null || selected === void 0 ? void 0 : selected.map(function (ele, idx) {
                        var _a, _b, _c;
                        var count = 0;
                        ((_a = ele.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                            ((_b = ele.list) === null || _b === void 0 ? void 0 : _b.map(function (l) {
                                if (l.selected)
                                    count++;
                            }));
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Accordion, { className: "main filter-accordion", 
                                //activeKey={ele.eventKey === selected[0].eventKey}
                                key: idx },
                                React.createElement(Accordion.Header, null,
                                    ele.filterName,
                                    React.createElement("span", { className: "color_blue" },
                                        "\u00A0 (",
                                        count,
                                        ")")),
                                React.createElement(Accordion.Body, null, ((_c = ele.list) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                                    (ele.selectType === "tab" ? (React.createElement(GenericTabs, { defaultActiveKey: ele.list[0].key, tabsArray: ele.list.map(function (x) {
                                            var _a;
                                            return {
                                                title: x.title,
                                                eventKey: x.key,
                                                tabContent: (React.createElement(EachFilter, { list: x.childlist.list, filterName: x.childlist.filterName, propertyKey: x.childlist.eventKey, selectedType: x.childlist.selectType, clear: (_a = x === null || x === void 0 ? void 0 : x.childlist) === null || _a === void 0 ? void 0 : _a.clear })),
                                            };
                                        }), callBackFunction: function (key) {
                                            var index = null;
                                            ele.list.filter(function (x, idx) {
                                                return x.key == key ? (index = idx) : null;
                                            });
                                            updateChecked(null, ele.filterName, index, setSelected, "tab");
                                        } })) : (React.createElement(EachFilter, { list: ele.list, filterName: ele.filterName, propertyKey: ele.eventKey, selectedType: ele.selectType, clear: ele === null || ele === void 0 ? void 0 : ele.clear })))))));
                    }))),
                React.createElement("div", { className: "mob-filterasset-drop-footer funds-footer" },
                    React.createElement("div", { className: "funds filterasset-drop-footer" },
                        React.createElement(EdButton
                        // className={
                        //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                        //     ? "filter-button-disable"
                        //     : "filter-button aply-btn"
                        // }
                        , { 
                            // className={
                            //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                            //     ? "filter-button-disable"
                            //     : "filter-button aply-btn"
                            // }
                            className: "filter-button aply-btn", value: "Apply", onClick: function () {
                                props.setSelectedFilters(selected);
                                props.setOpenFilter(false);
                            }, btnTyp: "blue-one" }))))))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "filterasset-drop DMSan_16_700 txt_blackOne1 ".concat(props.externalClassName) },
            !(props === null || props === void 0 ? void 0 : props.dontShowTitile) && (React.createElement("span", null,
                "Filters by",
                React.createElement("span", { className: "txt-midnight-blue RobotoM_16_500" },
                    "\u00A0(",
                    totalCounts,
                    ")"))),
            (selected === null || selected === void 0 ? void 0 : selected.length) > 0 &&
                (selected === null || selected === void 0 ? void 0 : selected.map(function (ele, idx) {
                    var _a, _b, _c;
                    var count = 0;
                    ((_a = ele === null || ele === void 0 ? void 0 : ele.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        ((_b = ele === null || ele === void 0 ? void 0 : ele.list) === null || _b === void 0 ? void 0 : _b.map(function (l) {
                            var _a, _b, _c, _d;
                            if (l.selected &&
                                l.title !== "NSE" &&
                                l.title !== "BSE") {
                                count++;
                            }
                            else if ((l === null || l === void 0 ? void 0 : l.childlist) &&
                                ((_b = (_a = l === null || l === void 0 ? void 0 : l.childlist) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                                return (_d = (_c = l.childlist) === null || _c === void 0 ? void 0 : _c.list) === null || _d === void 0 ? void 0 : _d.map(function (l) {
                                    if (l.selected)
                                        count++;
                                });
                            }
                        }));
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Accordion, { className: "filter-accordion", key: idx },
                            React.createElement(Accordion.Header, null,
                                ele.filterName,
                                React.createElement("span", { className: "color_blue" },
                                    "\u00A0 (",
                                    count,
                                    ")")),
                            React.createElement(Accordion.Body, null, ((_c = ele.list) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                                (ele.selectType === "tab" ? (React.createElement(GenericTabs, { defaultActiveKey: ele.list[0].key, tabsArray: ele.list.map(function (x) {
                                        var _a;
                                        return {
                                            title: x.title,
                                            eventKey: x.key,
                                            tabContent: (React.createElement(EachFilter, { list: x.childlist.list, filterName: x.childlist.filterName, propertyKey: x.childlist.eventKey, selectedType: x.childlist.selectType, clear: (_a = x === null || x === void 0 ? void 0 : x.childlist) === null || _a === void 0 ? void 0 : _a.clear })),
                                        };
                                    }), callBackFunction: function (key) {
                                        var index = null;
                                        ele.list.filter(function (x, idx) {
                                            return x.key == key ? (index = idx) : null;
                                        });
                                        updateChecked(null, ele.filterName, index, setSelected, "tab");
                                    } })) : (React.createElement(EachFilter, { list: ele.list, filterName: ele.filterName, propertyKey: ele.eventKey, selectedType: ele.selectType, clear: ele === null || ele === void 0 ? void 0 : ele.clear, selectAll: ele === null || ele === void 0 ? void 0 : ele.selectAll })))))));
                })),
            React.createElement("div", { className: "funds filterasset-drop-footer" },
                React.createElement(EdButton, { className: "filter-button clear_all", value: "Clear All", onClick: ClearAll, btnTyp: "blue-one" }),
                React.createElement(EdButton
                // className={
                //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                //     ? "filter-button-disable"
                //     : "filter-button aply-btn"
                // }
                , { 
                    // className={
                    //   JSON.stringify(selectedFilters) === JSON.stringify(initialState)
                    //     ? "filter-button-disable"
                    //     : "filter-button aply-btn"
                    // }
                    className: "filter-button aply-btn", value: "Apply", onClick: function () {
                        props === null || props === void 0 ? void 0 : props.setSelectedFilters(selected);
                        props === null || props === void 0 ? void 0 : props.setOpenFilter(false);
                        CountFunction();
                    }, disabled: counts === 0, btnTyp: "blue-one" }))))))) : ("")));
};
